import { useTranslation } from 'react-i18next';
import { Typography } from 'ui-kit';

import { Wrapper } from './styles';
export interface INoDataProps {
    text?: string;
    customTranslation?: boolean;
    translation?: string;
}

export const NoData = (props: INoDataProps) => {
    const { t } = useTranslation();
    const { translation = '', customTranslation = false, text = 'no.results.found' } = props;
    return (
        <Wrapper>
            {customTranslation ? (
                <Typography
                    variant="body1"
                    color="text.disabled"
                >
                    {translation}
                </Typography>
            ) : (
                <Typography
                    variant="body1"
                    color="text.disabled"
                >
                    {t(text)}
                </Typography>
            )}
        </Wrapper>
    );
};
